const MOCK_TOKENS = {
  size: {
    m: "body1",
    s: "body2"
  }
};
export {
  MOCK_TOKENS
};
